import { useQuery } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { chargeGuestsKey } from '@dashboard/lib/queryKeys';
import { fetcher } from '@dashboard/services/request';

// Null for bookings of events that don't collect guest details.
export default function useBookingGuests(payment) {
  const { sellerId, token } = useAuth();
  return useQuery({
    queryKey: chargeGuestsKey(payment?._id),
    queryFn: () => fetcher(`/sellers/${sellerId}/charges/${payment._id}/guests`, token),
    enabled: Boolean(payment?._id && payment.attendeeStatus && sellerId && token),
  });
}

export const bookingTicketCount = payment =>
  (payment.tickets ?? []).reduce((sum, ticket) => sum + (ticket.quantity ?? 0), 0);

export const missingGuestsLabel = guests => {
  const count = guests?.missingCount ?? 0;
  return count ? `${count} attendee${count === 1 ? '' : 's'} missing` : null;
};

export const guestsToReviewLabel = guests => {
  const count = (guests?.rows ?? []).filter(row => row.flagged && !row.reviewedAt).length;
  return count ? `${count} attendee${count === 1 ? '' : 's'} to review` : null;
};
